export function runtimeUrlForAgent(scriptUrl: string): string {
    const script = new URL(scriptUrl);
    const runtime = new URL('/runtime.js', script);
    const version = script.searchParams.get('v');
    if (version) runtime.searchParams.set('v', version);
    return runtime.href;
}
